import React from "react";

interface WelcomeCardProps {
  firstName: string;
  lastName: string;
  memberSince: string;
  level: number;
  xp: number;
  xpToNextLevel: number;
  progressPercentage: number;
  loading?: boolean;
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({
  firstName,
  loading = false,
}) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  if (loading) {
    return (
      <div className="relative overflow-hidden bg-gray-900 rounded-2xl p-6">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-700 rounded-lg w-64 mb-2"></div>
          <div className="h-4 bg-gray-800 rounded w-48"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden bg-gray-900 rounded-2xl p-6">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-blue-500 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-purple-500 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        {/* Left Section */}
        <div>
          <p className="text-gray-400 text-sm mb-1">{getGreeting()}</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-white">
            Welcome back, {firstName}
          </h1>
          <p className="text-gray-400 mt-2 text-sm">
            Keep up the great work! You're making progress.
          </p>
        </div>

        {/* Right Section - Level Progress */}
        {/* <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 min-w-[220px]">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center">
                <Zap className="w-4 h-4 text-white" />
              </div>
              <div>
                <p className="text-white font-semibold">Level {level}</p>
                <p className="text-gray-400 text-xs">{xp} total XP</p>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between text-xs">
              <span className="text-gray-400">Progress</span>
              <span className="text-white font-medium">
                {progressPercentage}%
              </span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2">
              <div
                className="bg-gradient-to-r from-yellow-400 to-orange-500 h-2 rounded-full transition-all duration-500"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <p className="text-gray-500 text-xs">
              {xpToNextLevel} XP until Level {level + 1}
            </p>
          </div>

          <Link
            to="/achievements"
            className="flex items-center justify-center gap-1 mt-3 text-sm text-gray-300 hover:text-white transition-colors"
          >
            View Achievements
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default WelcomeCard;
